// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__nWInT","log":"ModalInventoryLogs_log__3NBos","date":"ModalInventoryLogs_date__14DAT","userName":"ModalInventoryLogs_userName__3Yqyl"};